import Rolling from '@assets/gif/rolling.gif';
import CloseImage from '@assets/svg/close.svg';
import { ClickAwayListener } from '@material-ui/core';
import { CSSTransition } from 'react-transition-group';
import { useState } from '@hookstate/core';
import { IAutoComplete } from '@store/redux/features/search/searchSlice';
import { removeLastWord } from '@utils/removeLastWord/removeLastWord';
import Highlighter from 'react-highlight-words';
import { getLastWord } from '@utils/getLastWord/getLastWord';
import React, { MutableRefObject } from 'react';
import {
  Close,
  LoadingImg,
  Search,
  SearchContainer,
  Container,
  Div,
  Line,
  ShowOptions,
  DivFullWidth,
} from './SearchBarAutocomplete.styles';
import { StyledOptionAutoComplete } from '../SearchBarExpansiveWithHistory/SearchBarExpansiveWithHistory.styles';

interface SearchBarProps {
  showOptions: IAutoComplete[];
  searchText: string;
  placeholder: string;
  loadingSearch: boolean;
  isDisabled?: boolean;
  showErasedSearch: boolean;
  closeIconOnClick: () => void;
  onClickFilter: (input: IAutoComplete) => void;
  searchOnChange: any;
  setShowOptions: any;
  autoFocus?: boolean;
  option: number;
  setOption: (input: number) => void;
  inputRef: MutableRefObject<HTMLInputElement | null>;
}
const SearchBarAutocomplete = ({
  searchText,
  isDisabled,
  placeholder,
  searchOnChange,
  loadingSearch,
  showErasedSearch,
  closeIconOnClick,
  showOptions,
  onClickFilter,
  setShowOptions,
  autoFocus,
  option,
  setOption,
  inputRef,
}: SearchBarProps) => {
  const handleClickAway = () => {
    setShowOptions([]);
  };
  const onPressKeyboard = (event: any) => {
    if (event.keyCode === 38) {
      if (option - 1 >= 0) {
        setOption(option - 1);
      }
      event.preventDefault();
    }
    if (event.keyCode === 40) {
      if (option + 1 < showOptions.length) {
        setOption(option + 1);
      }
      event.preventDefault();
    }
  };
  const newInput = () => {
    const updatedSearch = removeLastWord(searchText);
    if (showOptions && option < showOptions.length)
      return updatedSearch.length > 0
        ? `${updatedSearch} ${showOptions[option].labelOne}`
        : `${showOptions[option].labelOne}`;

    return '';
  };
  const open = useState(false);
  return (
    <Div>
      <SearchContainer>
        <DivFullWidth>
          <Search
            ref={inputRef}
            autoComplete="off"
            value={option > -1 ? newInput() : searchText}
            disabled={isDisabled}
            placeholder={placeholder}
            onChange={e => {
              if (!isDisabled)
                searchOnChange(option > -1 ? newInput() : e.target.value);
            }}
            onKeyDown={e => {
              if (e.key === 'Enter' && onClickFilter) {
                onClickFilter(
                  option > -1
                    ? { labelOne: newInput() }
                    : { labelOne: searchText },
                );
              } else if (onPressKeyboard) onPressKeyboard(e);
            }}
            haveResults={showOptions.length > 0}
            autoFocus={autoFocus || undefined}
          />
        </DivFullWidth>
        {loadingSearch && !isDisabled && (
          <div>
            <LoadingImg src={Rolling} alt="loading" />
          </div>
        )}
        {showErasedSearch && searchText.length > 0 && !loadingSearch && (
          <Close src={CloseImage} alt="close" onClick={closeIconOnClick} />
        )}
      </SearchContainer>
      {showOptions.length > 0 && !loadingSearch && <Line />}
      {showOptions.length > 0 && !loadingSearch && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <ShowOptions haveResults={showOptions.length > 0}>
            <Container haveResults={showOptions.length > 0}>
              {showOptions.map((item, index) => (
                <StyledOptionAutoComplete
                  isActive={index === option}
                  key={item.labelOne}
                  onClick={() => {
                    onClickFilter(item);
                  }}
                >
                  <Highlighter
                    highlightClassName="text"
                    searchWords={[getLastWord(searchText)]}
                    autoEscape
                    textToHighlight={`${removeLastWord(searchText)} ${
                      item.labelOne
                    }`}
                  />
                </StyledOptionAutoComplete>
              ))}
            </Container>
          </ShowOptions>
        </ClickAwayListener>
      )}
      <CSSTransition
        in={open.get()}
        timeout={1}
        classNames="my-node"
        unmountOnExit
        onEnter={() => open.set(true)}
        onExited={() => open.set(false)}
      />
    </Div>
  );
};

export { SearchBarAutocomplete };
